export const getMessageWithEmojis = (field: HTMLTextAreaElement | null, emoji: string): string => {
  if (field === null) return '';
  const { selectionEnd, value } = field;
  return String(value.slice(0, selectionEnd) + emoji + value.slice(selectionEnd));
};
